/* eslint-disable import/no-anonymous-default-export */
import axiosClient from "../lib/api/axiosClient";
const endpoint = process.env.REACT_APP_API_ENDPOINT_ONE;
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const api_version = process.env.REACT_APP_API_VERSION;
// const api_version = "hello";

export default {
  postChangePin: (token, data, browserToken) =>
    axiosClient
      .post(`${endpoint}/api/v${api_version}/Auth/Change-PIN`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          browserToken: `${browserToken}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  postResetPin: (data) =>
    axiosClient
      .post(`${endpoint}/api/v${api_version}/Auth/Reset-PIN`, data)
      .then((res) => res.data)
      .catch((err) => err.response),
  postForgetPin: (phoneNumber) =>
    axiosClient
      .post(`${endpoint}/api/v${api_version}/Auth/Forget-PIN`, {
        phoneNumber,
        accountType: 3,
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  postSendCode: async ({ phoneNumber, email, dialCode, accountType }) => {
    let data = {
      phoneNumber,
      email,
      countryCode: dialCode,
      accountType,
    };
    console.log(data);

    try {
      const res = await axiosClient.post(
        `${endpoint}/api/v${api_version}/Auth/Send-Code`,
        data,
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  },

  postVerifyCode: ({ phoneNumber, code, accountType }) => {
    let data = {
      phoneNumber,
      code,
      accountType,
    };
    return axiosClient
      .post(`${endpoint}/api/v${api_version}/Auth/Verify-code`, data)
      .then((res) => res.data)
      .catch((err) => err.response);
  },

  postCreatePin: ({ phoneNumber, pin, browserToken, accountType }) => {
    let data = {
      phoneNumber,
      pin,
      browserToken,
      accountType,
    };

    return axiosClient
      .post(`${endpoint}/api/v${api_version}/Auth/Create-Pin`, data, {
        headers: {
          Authorization: `Bearer ${browserToken}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  authLogin: ({ phoneNumber, pin, browserToken, accountType }) => {
    let data = {
      phoneNumber,
      pin,
      browserToken,
      accountType,
    };
    // console.log(data);
    return axiosClient
      .post(`${endpoint_two}/api/v${api_version}/UserAccount/Adm-Auth`, data, {
        headers: {
          // Authorization: `Bearer ${browserToken}`,
          browserToken: `${browserToken}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response);
  },
  // admin account details
  admAccountDetails: (token) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/UserAccount/Adm-AccountDetails`,
        {
          headers: {
            authToken: `${token}`,
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => res.data)
      .catch((err) => err.response),
  userStaffProfile: (token) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/UserAccount/Staff-Profile`, {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
  addUserInformation: (token, data, type) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/UserAccount/${type}`, data, {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),
};

export const addUserInformation = (token, data, type) =>
  axiosClient
    .post(`${endpoint_two}/api/v${api_version}/UserAccount/${type}`, data, {
      headers: {
        authToken: `${token}`,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);

export const userStaffProfile = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/Staff-Profile/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//Personal Data
export const personalData = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/personal-data/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const updatePersonalData = (token, payload, staffId) =>
  axiosClient
    .put(
      `${endpoint_two}/api/v${api_version}/UserAccount/update-personal-data/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//Experience
export const getExperience = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/experience/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createExperience = (token, payload, staffId) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/Add-Experience/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const deleteExperience = (token, id) =>
  axiosClient
    .delete(
      `${endpoint_two}/api/v${api_version}/UserAccount/experience?id=${id}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//Certification
export const getCertifications = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/certifications/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createCertifications = (token, payload, staffId) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/Add-Certification/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const deleteCertifications = (token, id) =>
  axiosClient
    .delete(
      `${endpoint_two}/api/v${api_version}/UserAccount/certification?id=${id}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);
//Next of Kin
export const getNOK = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/nextofkins/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createNOK = (token, payload, staffId) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/Add-NextofKin/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const deleteNOK = (token, id) =>
  axiosClient
    .delete(
      `${endpoint_two}/api/v${api_version}/UserAccount/nextofkin?id=${id}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);
//Attachment
export const getAttachments = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/attachments/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createAttachments = (token, payload, staffId) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/add-update-attachments/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const deleteAttachments = (token, id) =>
  axiosClient
    .delete(
      `${endpoint_two}/api/v${api_version}/UserAccount/nextofkin?id=${id}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//References
export const getReferences = (token, staffId) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/employee-reference/${staffId}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createReference = (token, payload, staffId) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/add-update-employee-reference/${staffId}`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//Submit
export const updateStatus = (token, payload) =>
  axiosClient
    .put(
      `${endpoint_two}/api/v${api_version}/UserAccount/change-staff-status`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

//LEAVES
export const getLeavesType = (token) =>
  axiosClient
    .get(`${endpoint_two}/api/v${api_version}/UserAccount/leave-types`, {
      headers: {
        authToken: `${token}`,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);

export const getLeaveRequestTypes = (token) =>
  axiosClient
    .get(`${endpoint_two}/api/v${api_version}/UserAccount/request-types`, {
      headers: {
        authToken: `${token}`,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);

export const getLeaveHistories = (
  token,
  staffId,
  searchText,
  pageSize,
  pageNumber,
) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/UserAccount/request-histories/${staffId}?SearchText=${searchText}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const createUpdateLeave = (token, payload) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/UserAccount/create-update-staff-request`,
      payload,
      {
        headers: {
          authToken: `${token}`,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);
